require('../../js/theme');
require('./politica-de-privacidade.scss');